import { AlertTriangle, LayoutDashboard, LogOut, Store, Users } from 'lucide-react';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../../assets/img/logo.png';
import styles from '../../assets/scss/layout/SuperAdminSidebar.module.scss';
import { version } from '../../config/version-code';

export default function SuperAdminSidebar({ collapsed, mobileOpen, onClose }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        navigate('/navo-admin/login');
    };

    const linkClass = ({ isActive }) =>
        `${styles.sidebarLink}${isActive ? ` ${styles.sidebarLinkActive}` : ''}`;

    const handleNavClick = () => {
        if (onClose) onClose();
    };

    const menuItems = [
        { to: '/navo-admin/dashboard', icon: <LayoutDashboard />, label: 'Dashboard', end: true },
        { to: '/navo-admin/shops', icon: <Store />, label: 'Quản lý Shops' },
        { to: '/navo-admin/users', icon: <Users />, label: 'Quản lý Users' },
        { to: '/navo-admin/notes', icon: <AlertTriangle />, label: 'Lưu ý' },
    ];

    return (
        <aside
            className={[
                styles.sidebar,
                collapsed ? styles.sidebarCollapsed : '',
                mobileOpen ? styles.sidebarMobileOpen : '',
            ].join(' ')}
        >
            <div className={styles.sidebarHeader}>
                <div className={styles.sidebarLogoIcon}>
                    <img src={logo} alt="Navo" />
                </div>
                <div className={styles.sidebarLogoText}>
                    <span className={styles.sidebarLogoTitle}>Navo Sổ Tiệm</span>
                    <span className={styles.sidebarLogoSub}>Super Admin</span>
                </div>
            </div>

            <nav className={styles.sidebarNav}>
                {menuItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={linkClass}
                        onClick={handleNavClick}
                        end={item.end}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </nav>

            <div className={styles.sidebarFooter}>
                <button className={styles.sidebarLogout} onClick={handleLogout}>
                    <LogOut />
                    <span>Đăng xuất</span>
                </button>
                <p className={styles.sidebarVersion}>Phiên bản: {version}</p>
            </div>
        </aside>
    );
}
